import { render, staticRenderFns } from "./ModalPromoAccept.vue?vue&type=template&id=032d61a2"
import script from "./ModalPromoAccept.vue?vue&type=script&lang=js"
export * from "./ModalPromoAccept.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports